var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ArrowDownThin = function ArrowDownThin(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 11 7' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M10.073 1.69L9.345.926 5.073 5.4.802.927l-.729.762 5 5.238z', fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default ArrowDownThin;
//# sourceMappingURL=ArrowDownThin.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ArrowDownThin.js